import {Card} from "./Card/Card";

export const commentProps = {
    commentable_type: {
        default: 'product'
    },
    commentable_id: {
        default: null
    },
    commentCard: {
        options: Object.keys(Card),
        default: 'mCommentCard1',
    },
    commentCardClass: {
        default: 'my-2',
    }
}